import firebase from 'firebase/app';
import 'firebase/storage';
import 'firebase/firestore';

const app = firebase.initializeApp({
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
});

const db = app.firestore();
const useEmulator = process.env.REACT_APP_USE_EMULATOR === 'true';
const useSecureEmulatorProxy = useEmulator
  && process.env.REACT_APP_EMULATOR_USE_HTTPS === 'true';
const emulatorHost = process.env.REACT_APP_EMULATOR_HOST || 'localhost';

db.settings(useSecureEmulatorProxy ? {
  host: emulatorHost,
  ssl: true,
  ignoreUndefinedProperties: true,
} : { ignoreUndefinedProperties: true });

// Desenvolvimento: aponta Firestore/Storage para o Firebase Emulator
if (useEmulator) {
  const firestorePort = Number(process.env.REACT_APP_FIRESTORE_EMULATOR_PORT || 8085);
  const storagePort = Number(process.env.REACT_APP_STORAGE_EMULATOR_PORT || 9199);

  if (useSecureEmulatorProxy) {
    // A versão compat do Storage aceita um host com protocolo explícito.
    // Assim as URLs /v0 do emulador seguem pelo proxy HTTPS.
    // eslint-disable-next-line no-underscore-dangle
    app.storage()._delegate._host = `https://${emulatorHost}`;
  } else {
    db.useEmulator(emulatorHost, firestorePort);
    app.storage().useEmulator(emulatorHost, storagePort);
  }
}

export { app };
